import { getRequest, postRequest } from './api'
import { API_URL_WORKORDER } from '../constants/index'

export async function save(
  contractID,
  workOrderID,
  protocolID,
  protocolAssignmentID,
  protocol1,
  protocol2,
  protocol3,
  protocol4,
  protocol5,
  protocol6,
  protocol7,
  protocol8,
  protocol9,
  protocol10,
  protocol11,
  protocol12,
) {
  return postRequest(`${API_URL_WORKORDER}protocolHistory`, {
    values: {
      contractID,
      workOrderID,
      protocolID,
      protocolAssignmentID,
      protocol1,
      protocol2,
      protocol3,
      protocol4,
      protocol5,
      protocol6,
      protocol7,
      protocol8,
      protocol9,
      protocol10,
      protocol11,
      protocol12,
    },
  })
}

export async function find(id) {
  return getRequest(`${API_URL_WORKORDER}protocolHistory/${id}`)
}
